import { useCallback, useEffect, useState } from "react";
import { useService } from "../../../../../hooks";

export const usePaytmTotal = ({ data, action }) => {
  const { fetch } = useService("DashboardWidget");
  const { getFormattedDate } = useService("Misc");
  const defaultQuery = {
    table: "payment",
    filter: {
      date: {
        start: getFormattedDate(new Date("01-01-1990")),
        end: getFormattedDate(new Date()),
      },
    },
    attr: {},
  };
  const [count, setcount] = useState<number>(0);
  const [status, setstatus] = useState(null);
  const [title, settitle] = useState(data.title);
  const [query, setquery] = useState(
    Object.keys(data.setting).length ? data.setting : defaultQuery
  );

  const fetchCount = useCallback(async () => {
    let result = await fetch("count", query);
    if (result.status) setcount(result.data);
  }, [fetch, query]);

  const applyFilters = useCallback(
    async (e) => {
      e.preventDefault();
      let queryData = query;
      queryData.attr = { STATUS: status?.value };
      await setquery(queryData);
      fetchCount();
      action.updateWidget({
        ...data,
        title,
        configure: false,
        setting: queryData,
      });
    },
    [action, data, fetchCount, query, status?.value, title]
  );

  const changeStatus = (e) => setstatus(e);

  const setWidgetTitle = (e) => settitle(e.target.value);

  useEffect(() => {
    fetchCount();
  }, [fetchCount]);
  return {
    applyFilters,
    setWidgetTitle,
    title,
    status,
    changeStatus,
    count,
  };
};
